/*eslint-disable */
<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div style="gap: 12px;" class="col-12 col-sm-6 col-md-6 col-lg-6 d-flex align-items-center">
            <h4>
              <i class="fa fa-solid ri-user-star-fill" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              {{isApprove ? cvCardTitleIsApprove : cvCardTitle}}
            </h4>
            <NotificationsModal :propNotificationObj="propNotificationObj" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'"/>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="gotoInviteUser" v-if="isApprove">{{cvbtnCreateSession}}</b-button>
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="goToCalendar">{{cvbtnBlockCalendar}}</b-button>
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="gotoFirefliesDashboard">{{cvbtnFirefliesDashboard}}</b-button>
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="gotoSpcmCounsellorTeamDashboard">{{cvbtnSpcmCounsolerDashboard}}</b-button>
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="gotoSpcmCaseSummary" v-if="userData.user_role == 'USERROLE11111'">{{cvbtnSpcmCaseSummary}}</b-button>
          </div>
        </div>

        <div class="iq-card row p-3" >
          <b-col lg="10" xl="10">
            <b-row class="col-10">
              <b-col class="col-12 mb-3">
                <b-form-input
                  id="search"
                  v-model="search_param"
                  type="search"
                  :placeholder="cvSearchText"
                  @input="searchFromBackend">
                </b-form-input>
              </b-col>
            </b-row>

            <b-row class="col-12">
              <!-- Counselor Name Filter -->
              <b-col sm="4" md="4" lg="3" xl="2" class="mb-2">
                <select v-model="whereFilter.counsellor_id" class="form-control" @change="setCounsellor" v-if="counsellorObjList?.length > 0" title="Counselor List">
                  <option :value="null" disabled>Choose Counselor</option>
                  <option :value=null>All</option>
                  <option v-for="(counsellor, index) of sortedCounsellorList" :key="(index+1)" :value="counsellor.counsellor_user_id">
                    {{counsellor.user_name}}
                  </option>
                </select>
              </b-col><!-- Counselor Name Filter -->

              <!-- SPCM Category Ex. GIDE ONE, EXCLUSIVE Etc -->
              <b-col sm="4" md="4" lg="3" xl="2" class="mb-2">
                <select v-model="whereFilter.spcm_category" class="form-control" @change="spcmList()">
                  <option :value="null" disabled>Choose Category</option>
                  <option :value=null>All</option>
                  <option v-for="(category, index) of SPCM_CATEGORY_LIST" :key="(index+1)" :value="category.spcm_category">
                    {{category.spcm_category}}
                  </option>
                </select>
              </b-col><!-- SPCM Category -->

              <!-- Counselling Status -->
              <b-col sm="4" md="4" lg="3" xl="2" class="mb-2">
                <select v-model="whereFilter.spcm_state" class="form-control" @change="spcmList()">
                  <option :value="null" disabled>Choose Status</option>
                  <option :value=null>All</option>
                  <option v-for="(state, index) of SPCM_STATE_LIST" :key="(index+1)" :value="index">
                    {{state}}
                  </option>
                </select>
              </b-col><!-- Counselling Status -->

              <!-- Class Filter -->
              <b-col sm="4" md="4" lg="3" xl="2" class="mb-2">
                <select v-model="whereFilter.Class" class="form-control" @change="spcmList()">
                  <!-- <option v-for="(Class, index) of filteredClasses" :key="index+'OrgType'">{{ Class }}</option> -->
                  <option v-for="(item, index) in filteredClasses" :key="index+'OrgType'" :value="item.value">
                   {{ item.label }}
                  </option>
                </select>
              </b-col>
              <!-- Class Filter -->

              <!-- University Filter -->
              <b-col sm="4" md="4" lg="4" xl="4" class="mb-2">
                <multiselect for="validationmodule_name"
                  v-model="universityFilterObj"
                  :options="univFiltersList['org_name , org_id']"
                  placeholder= "Choose University"
                  track-by="org_id"
                  label="org_name"
                  @input="spcmList(false)"
                  class="secondary-color"
                  style="line-height:35px; background: transparent; border-radius: 30px; font-size: 14px"
                >
                  <span slot="noResult">University Not found</span>
                </multiselect>
              </b-col><!-- University Filter -->
            </b-row>
          </b-col>
          <!-- Download CSV, Remove Filter button -->
          <b-col class="mb-2 col-12 col-lg-2 mb-3">
            <i class="fa-solid fa-file-csv Download_button" title="Download CSV" @click="backendCsvDownload"></i>
            <i class="fa-solid fa-filter-circle-xmark Download_button" title="Remove Filters" @click="removeAllFilter"></i>
          </b-col><!-- Download CSV, Remove Filter button -->
        </div>

        <div class="iq-card row p-3" id="CounsellingApp" :key="updateInfo">
          <b-col class="container_minheight" md="12" v-if="spcmObjList && spcmObjList.length > 0">
            <b-table
              hover
              responsive
              :items="spcmObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentBatchNo"
              :per-page="dataPerPage"
              :busy="isBusy"
            >
              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Loading Data...</strong>
                </div>
              </template>

              <template v-slot:cell(id)="data">
                <span style="display: block;width: 50px" title="View Session Details">{{spcmObjList.indexOf(data.item)+1}}</span>
              </template>

              <template v-slot:cell(user_name)="data">
                <span class="pointer" @click="viewDetails(`/user/${data.item.user_id}`)"> {{ data.item.user_name }}</span><br>
                <span><small>
                  Id:&nbsp;{{ data.item.user_id }}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy User Id" @click="doCopy(data.item.user_id)"></i><br>
                  Email:&nbsp;{{ data.item.user_email }}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy User Email" @click="doCopy(data.item.user_email)"></i><br>
                  Mobile:&nbsp;{{data.item.user_mobile}}
                </small></span><br>
                <div class="button_align mt-2">
                  <template v-if="adminView">
                    <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="showChangeCounsellor(data.item)" size="sm" title="Change Strategist"><i class="fa fa-shuffle font-size-20" aria-hidden="true"></i></b-button>
                    <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="spcmStudentCounsellorTeam('MODAL', data.item)" size="sm" title="View Team"><i class="fa-solid fa-users font-size-20" aria-hidden="true"></i></b-button>
                    <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="showSpcmDeleteDialog(data.item)" size="sm"><i class="fa-solid fa-trash font-size-20" aria-hidden="true"></i></b-button>
                    <!-- <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="openReport(data.item.report)" v-if="data.item.report" size="sm" title="View GPaths Report"><i class="fa-solid fa-map-signs font-size-20" aria-hidden="true"></i></b-button> -->
                    <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="spcm_country_strategyAdd('MODAL', data.item)" size="sm" title="Update Country Strategy"><i class="fa fa-map-marker font-size-20" aria-hidden="true"></i></b-button>
                    <b-button class="btn btn actionIcon font-size-16 mr-1 mb-1 btn-secondary btn-sm" @click="viewSpcmActivity(data.item)" title="GIDE Activity"><i class="fa fa-calendar font-size-18" aria-hidden="true"></i></b-button>
                    <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="viewSessionDetails(data.item.spcm_id)" size="sm" title="View Session Details"><i class="ri-user-star-fill font-size-20" aria-hidden="true"></i></b-button>
                  </template>
                  <template v-else-if="counsellorView">
                    <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="showChangeCounsellor(data.item)" size="sm" title="Change Strategist"><i class="fa fa-shuffle font-size-20" aria-hidden="true"></i></b-button>
                    <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="spcmStudentCounsellorTeam('MODAL', data.item)" size="sm" title="View Team"><i class="fa-solid fa-users font-size-20" aria-hidden="true"></i></b-button>
                    <!-- <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="openReport(data.item.report)" v-if="data.item.report" size="sm" title="View GPaths Report"><i class="fa-solid fa-map-signs font-size-20" aria-hidden="true"></i></b-button> -->
                    <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="spcm_country_strategyAdd('MODAL', data.item)" size="sm" title="Update Country Strategy"><i class="fa fa-map-marker font-size-20" aria-hidden="true"></i></b-button>
                    <b-button class="btn btn actionIcon font-size-16 mr-1 mb-1 btn-secondary btn-sm" @click="viewSpcmActivity(data.item)" title="GIDE Activity"><i class="fa fa-calendar font-size-18" aria-hidden="true"></i></b-button>
                    <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="viewSessionDetails(data.item.spcm_id)" size="sm" title="View Session Details"><i class="ri-user-star-fill font-size-20" aria-hidden="true"></i></b-button>
                  </template>
                </div>
              </template>

              <template v-slot:cell(grade)="data">
                <p>
                  Class:&nbsp;{{ fixedClassName(data.item.edu_class_name) }}&nbsp;<br>
                  Board: {{ data.item.board_name }}
                </p>
              </template>

              <template v-slot:cell(university)="data">
                <div v-if="data.item.university">
                  <span>{{ data.item.university }}</span><br>
                  <small>
                    <span>Course:&nbsp;{{ data.item.cour_name }}</span><br>
                    <span>Intake:&nbsp;{{ data.item.batch }}</span><br>
                    <span>Appl. Deadline:&nbsp;{{ data.item.org_application_deadline_forstudent && data.item.org_application_deadline_forstudent != "null" ? data.item.org_application_deadline_forstudent : "-" }}</span><br><br>
                  </small>
                  <span><b-badge title="View All University Applications" variant="primary" class="text-wrap pointer mr-4" @click="gotoAdmissionDashboard(data.item.user_id)">View All</b-badge></span>
                </div>
                <div v-else>
                  <b-badge title="Change Status" @click="showSpcmStatusUpdateOpenDialog(data.item)" class="text-wrap pointer" :style="getCounsellingStateColorCode(data.item.spcm_state)">{{ SPCM_STATE_LIST[data.item.spcm_state] }}</b-badge>
                </div>
              </template>

              <template v-slot:cell(parent_details)="data">
                <span>
                  {{ data.item.parent_name }}<br>
                  <small>
                  Email:&nbsp;{{ data.item.parent_email }}<br>
                  Mobile:&nbsp;{{data.item.parent_mobile}}
                  </small>
                </span>
              </template>

              <template v-slot:cell(exam_name)="data">
                <div v-for="(examObj, examName) in getProgramAndTest(data.item.exam_name)" :key="examName" class="mb-0">
                  <div class="mb-1 p-0">
                    <span>
                      {{ examObj.exam_name }} <span v-if="examObj.subject_name">({{ examObj.subject_name }})</span>: {{ examObj.total_score }}
                    </span>
                    <small>{{ examObj.exam_date }}</small><br>
                  </div>
                </div>
                <div>
                  <b-badge class="text-wrap pointer" variant="primary" v-if="data.item.exam_name"  @click="showProgramTestModel(data.item)">View Score</b-badge>
                </div>
              </template>

              <template v-slot:cell(spcm_state)="data">
                <b-badge title="Change Status" @click="showSpcmStatusUpdateOpenDialog(data.item)" class="text-wrap pointer" :style="getCounsellingStateColorCode(data.item.spcm_state)">{{ SPCM_STATE_LIST[data.item.spcm_state] }}</b-badge>
              </template>

              <template v-slot:cell(ms_country_strategy)="data">
                <b-button @click="spcm_country_strategyAdd('MODAL', data.item)" class="btn btn actionIcon font-size-18 mr-1 btn-sm">
                  <i class="fa fa-map-marker m-0 font-size-20"></i>
                </b-button>
                {{data.item.ms_country_strategy ? data.item.ms_country_strategy : "--"}}
              </template>

              <!-- <template v-slot:cell(spcm_id)="data">
                <span v-if="data.item.latest_counselor_notes && data.item.latest_counselor_notes.length > 0" @click='viewSessionDetails(data.item.spcm_id)' v-html="getNotes(data.item)"></span>
                <span v-else>
                  <span @click='viewSessionDetails(data.item.spcm_id)' class="pointer">
                    <b-badge class="" variant="primary">Add Notes</b-badge>
                  </span>
                </span>
              </template> -->

              <template v-slot:cell(spcm_category)="data">
                <div class="mb-2" v-if="data.item?.spcm_category?.includes('TESTSERIES') && data.item.tprep_id">
                  <b-badge title="Change Student's Counseling Plan" class="text-wrap pointer mr-2 w-200px" :style="'background:'+getBgFor('SPCM-TESTSERIES')" @click="showSpcmCategoryUpdateOpenDialog(data.item)">{{data.item?.spcm_category}}</b-badge>
                  <b-badge title="Counseling TnC Accepted" v-if="data.item.tprep_tnc == '1'" class="text-wrap" :style="getCounsellingStateColorCode('tnc_1')">
                    Contract Accepted
                  </b-badge>
                  <b-badge title="Counseling TnC Not Accepted"  v-if="data.item.tprep_tnc == '0'" class="text-wrap" :style="getCounsellingStateColorCode('tnc_0')">
                    Contract Not Accepted
                  </b-badge>
                </div>

                <hr style="border: 1px solid #ddd" v-if="(data.item?.spcm_category?.includes('TESTSERIES')) && (data.item?.spcm_category?.includes('GIDEPREP') || data.item?.tprep_tnc == 1 || data.item?.tprep_tnc == '1' || data.item.tprep_id)"/>

                <div class="mb-2" v-if="data.item?.spcm_category?.includes('GIDEPREP') || data.item?.tprep_tnc == 1 || data.item?.tprep_tnc == '1' || data.item.tprep_id">
                  <b-badge title="Change Student's Counseling Plan" class="text-wrap pointer mr-2 w-200px" :style="'background:'+getBgFor('SPCM-GIDEPREP')" @click="showSpcmCategoryUpdateOpenDialog(data.item)">SPCM-GIDEPREP</b-badge>

                  <b-button class="btn btn actionIcon font-size-20 btn-secondary btn-sm" @click="viewContract(data.item, 'SPCM-GIDEPREP')" size="sm" title="GIDE TestPreperation Contract">
                    <i v-if="data.item.tprep_tnc == '0'" class="fa-solid fa-file-contract font-size-20" aria-hidden="true"></i>
                    <i v-else class="fa-solid fa-file-contract font-size-20 primary-success" aria-hidden="true"></i>
                  </b-button>

                  <div v-if="adminView">
                    <b-badge title="Student Not Invited to GIDEPrep" class="mr-2 text-wrap pointer" :style="getCounsellingStateColorCode('student_not_invited')" v-if="!data.item.tprep_id">Approved</b-badge>
                    <b-badge title="Approve Student for Onboarding" @click="spcmApprove(data.item, 0, 'GIDEPREP')" class="mr-2 text-wrap pointer" :style="getCounsellingStateColorCode('approve')" v-if="isApprove && data.item.tprep_deleted == 2">Approve</b-badge>
                    <b-badge title="Approved Student" @click="spcmApprove(data.item, 2, 'GIDEPREP')" class="mr-2 text-wrap pointer" :style="getCounsellingStateColorCode('approved')" v-if="isApprove && data.item.tprep_deleted == 0">Approved</b-badge>

                    <b-badge title="Counseling TnC Accepted" v-if="data.item.tprep_tnc == '1'" class="text-wrap" :style="getCounsellingStateColorCode('tnc_1')">
                      Contract Accepted
                    </b-badge>
                    <b-badge title="Counseling TnC Not Accepted"  v-if="!data.item.tprep_tnc || data.item.tprep_tnc == '0' || data.item.tprep_tnc == 0" class="text-wrap" :style="getCounsellingStateColorCode('tnc_0')">
                      Contract Not Accepted
                    </b-badge>

                    <span v-if="!data.item.tprep_deleted || data.item.tprep_deleted == 0 || data.item.tprep_deleted == '0'">
                      <!-- Show TnC Switch only if the student is approved -->
                      <b-button class="btn btn actionIcon font-size-20 mr-1 btn-secondary btn-sm" @click="contractTnCAccept(data.item, 'SPCM-GIDEPREP')" v-if="isApprove">
                        <i v-if="!data.item.tprep_tnc || data.item.tprep_tnc == '0' || data.item.tprep_tnc == 0" class="fa fa-toggle-off font-size-20" aria-hidden="true" title="Accept Contract on behalf of Parent"></i>
                        <i v-else class="fa fa-toggle-on font-size-20" style="color: green;" aria-hidden="true" title="Contract Accepted on behalf of Parent. Click to reject"></i>
                      </b-button>
                    </span>
                  </div>
                </div>

                <hr style="border: 1px solid #ddd" v-if="(data.item?.spcm_category?.includes('EXCLUSIVE') || data.item.spcm_tnc == 1 || data.item.spcm_tnc == '1') && (data.item?.spcm_category?.includes('GIDEPREP') || data.item?.tprep_tnc == 1 || data.item?.tprep_tnc == '1' || data.item.tprep_id)"/>

                <div class="mb-2" v-if="data.item?.spcm_category?.includes('EXCLUSIVE') || data.item.spcm_tnc == 1 || data.item.spcm_tnc == '1'">
                  <b-badge title="Student Not Invited to Exclusive" class="mr-2 text-wrap pointer" :style="getCounsellingStateColorCode('student_not_invited')" v-if="!data.item.spcm_id">Approved</b-badge>
                  <b-badge title="Change Student's Counseling Plan" class="text-wrap pointer mr-2 w-200px" :style="'background:'+getBgFor('GIDE-EXCLUSIVE')" @click="showSpcmCategoryUpdateOpenDialog(data.item)">GIDE-EXCLUSIVE</b-badge>
                  <b-button class="btn btn actionIcon font-size-20 mr-1 btn-secondary btn-sm" @click="viewContract(data.item, 'GIDE-EXCLUSIVE')" size="sm" title="GIDE Exclusive Contract">
                    <i v-if="data.item.spcm_tnc == '0'" class="fa-solid fa-file-contract font-size-20" aria-hidden="true"></i>
                    <i v-else class="fa-solid fa-file-contract font-size-20 primary-success" aria-hidden="true"></i>
                  </b-button>
                  <div v-if="adminView">
                    <b-badge title="Approve Student for Onboarding" @click="spcmApprove(data.item, 0, 'EXCLUSIVE')" class="mr-2 text-wrap pointer" :style="getCounsellingStateColorCode('approve')" v-if="isApprove && data.item.deleted == 2">Approve</b-badge>
                    <b-badge title="Approved Student" @click="spcmApprove(data.item, 2, 'EXCLUSIVE')" class="mr-2 text-wrap pointer" :style="getCounsellingStateColorCode('approved')" v-if="isApprove && data.item.deleted == 0">Approved</b-badge>

                    <b-badge title="Counseling TnC Accepted" v-if="data.item.spcm_tnc == '1'" class="text-wrap" :style="getCounsellingStateColorCode('tnc_1')">
                      Contract Accepted
                    </b-badge>
                    <b-badge title="Counseling TnC Not Accepted"  v-if="!data.item.spcm_tnc || data.item.spcm_tnc == '0'" class="text-wrap" :style="getCounsellingStateColorCode('tnc_0')">
                      Contract Not Accepted
                    </b-badge>

                    <span v-if="data.item.deleted == 0 || data.item.deleted == '0'">
                      <!-- Show TnC Switch only if the student is approved -->
                      <b-button class="btn btn actionIcon font-size-20 mr-1 btn-secondary btn-sm" @click="contractTnCAccept(data.item, 'GIDE-EXCLUSIVE')" v-if="isApprove">
                        <i v-if="!data.item.spcm_tnc || data.item.spcm_tnc == '0'" class="fa fa-toggle-off font-size-20" aria-hidden="true" title="Accept Contract on behalf of Parent"></i>
                        <i v-else class="fa fa-toggle-on font-size-20" style="color: green;" aria-hidden="true" title="Contract Accepted on behalf of Parent. Click to reject"></i>
                      </b-button>
                    </span>
                  </div>
                </div>
              </template>

              <template v-slot:cell(strategist)="data">
                <div class="pointer" title="Change Strategist" @click="showChangeCounsellor(data.item)">
                  <span class="">
                    <span>{{ data.item.counsellor_name && data.item.counsellor_id != 1 ? data.item.counsellor_name : 'Awaiting Allocation' }}</span>
                    <b-button class="btn btn actionIcon font-size-18 btn-sm">
                      <i class="fa-solid fa-shuffle font-size-20"></i>
                    </b-button>
                  </span>
                </div>
              </template>

              <template v-slot:cell(sales_person)="data">
                <span v-if="data.item.sales_user_id" :title="data.item.sales_user_email">
                  {{ data.item.sales_user_name}}
                </span>
                <span v-else-if="data.item.tprep_sales_user_id" :title="data.item.tprep_sales_user_email">
                  {{ data.item.tprep_sales_user_name}}
                </span>
              </template>

              <template v-slot:cell(created_on)="data">
                {{ data.item.created_on | dateFormatDDMMMYYYYHHMMA }}
              </template>
            </b-table>
          </b-col>
          <b-col class="container_minheight" md="12" v-else>
            <span v-if="isApprove">
              We did not find any student records for your to approve.
            </span>
            <span v-else>
              We did not find any counseling records or you are not authorised to view this student data.
            </span>
          </b-col>
          <b-col class="my-1 d-flex align-items-center justify-content-between w-100" v-if="spcmObjList?.length > 10">
            <b-btn variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn">Load More</b-btn>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <!-- Spcm Create Your Custom Session -->
    <b-modal
      v-model="showInviteUserModal"
      scrollable
      :title="cvModalTitle"
      size="xxl"
      id="inviteModal"
    >
      <InviteUser :propProductCode="'spcm'" :propProductName="'COUNSELING'" :propOpenedInModal="true" :propCounsellor="userData" :propsalesQuestionObj="salesQuestionObj" @emitCloseInviteUser="emitCloseInviteUser"/>
      <template #modal-footer="">
        <b-button size="sm" @click="inviteUserModalClose()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>
    <!-- Spcm Create Your Custom Session  -->

    <!-- Allot student a different counsellor -->
    <b-modal
      v-model="showChangeCounsellorModal"
      v-if="showChangeCounsellorModal"
      id="change-counsellor-modal"
      scrollable
      :title="cvChangeCounsellorModalTitle"
      size="lg"
    >
      <ChangeStrategist :propOpenedInModal="true" :propUserObj="propSpcmUser" :propPdtCode="'spcm'" @emitCloseChangeCounselllor="emitCloseChangeCounselllor" />
      <template #modal-footer="">
        <b-button size="sm" @click="emitCloseChangeCounselllor()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>
    <!-- Allot student a different counsellor -->

    <!-- Update SPCM Status -->
    <b-modal v-model="showModelSpcmStatusUpdate" size="sm" title="Update Status" ok-title="Update" cancel-title="Cancel">
        <!-- Counselling Status -->
        <b-col sm="12" md="12" lg="12" xl="12" class="mb-2">
          <select v-model="whereFilter.spcm_state" class="form-control">
            <option :value="null" disabled>Choose Status</option>
            <option v-for="(state, index) of SPCM_STATE_LIST" :key="(index+1)" :value="index">
              {{state}}
            </option>
          </select>
        </b-col><!-- Counselling Status -->

      <template #modal-footer="">
        <b-button size="sm" @click="showModelSpcmStatusUpdate = false">{{cvbtnModalCancel}}</b-button>
        <b-button size="sm" variant="primary" @click="spcmStatusUpdate(spcmObj, whereFilter.spcm_state)">Update</b-button>
      </template>
    </b-modal><!-- Update SPCM Status -->

    <b-modal v-model="showModelSpcmDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelSpcmDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="spcmDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <!-- Add Spcm Country Strategy-->
    <b-modal
      v-model="showModelSpcm_Country_StrategyAdd"
      v-if="showModelSpcm_Country_StrategyAdd"
      scrollable
      :title="cvAddStrategyModalHeader">
      <spcmCountryStrategyAdd :propOpenedInModal="true" :propstrategyObj="spcmStrategyObj" @emitCloseSpcmStretegyModal="closeSpcmCountryStrategyModal"/>
    </b-modal><!-- Add Spcm Country Strategy-->

    <!--Spcm Student Counsellor Team -->
    <b-modal
      v-model="showModelSpcmStudentCounsellorTeam"
      scrollable
      :title="cvSpcmStudentCounsellorTeamModalHeader"
      size="xxl"
      hide-footer>
      <SpcmStudentCounsellorTeam :propStudentCounselorTeam="true" :propOpenedInModal="true" :propStudentCounsellorObj="StudentCounsellorTeamObj" @emitCloseStudentCounsellorTeamModal="closeStudentCounsellorTeamModal" />
    </b-modal><!-- Spcm Student Counsellor Team -->

     <!-- Update SPCM Category -->
     <b-modal v-model="showModelSpcmCategoryUpdate" size="sm" title="Change Student's Counselling Plan" ok-title="Update" cancel-title="Cancel">
      <b-col sm="12" md="12" lg="12" xl="12" class="mb-2">
        <select v-model="new_spcm_category" class="form-control">
          <option :value="null" disabled>Choose Category</option>
          <option v-for="(category, index) of SPCM_CATEGORY_LIST" :key="(index+1)" :value="category.spcm_category">
            {{category.spcm_category}}
          </option>
        </select>
      </b-col>
      <template #modal-footer="">
        <b-button size="sm" @click="showModelSpcmCategoryUpdate = false">{{cvbtnModalCancel}}</b-button>
        <b-button size="sm" variant="primary" @click="spcmCategoryUpdate(spcmObj, new_spcm_category)">Change</b-button>
      </template>
    </b-modal><!-- Update SPCM Category -->

    <!-- Gide Contract -->
    <b-modal
      v-model="showModalGideContracts"
      scrollable
      size="xxl"
      title="GIDE Contract"
    >
      <GideContract :propOpenedInModal="true" :propGideContractInEditMode="isApprove" :propGideContractObj="gideCounselingContractObj" @emitContractTnCAccept="contractTnCAccept"/>
      <template #modal-footer="">
        <b-button size="sm" @click="closeGIDECounselingContractModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>
    <!-- Gide Contract -->

    <!-- showProgramTestModal -->
    <b-modal v-model="showProgramTestModal" size="xxl" title="Student Exam details " ok-title="Update" cancel-title="Cancel">
     <div v-if="userProgramTest && Object.keys(userProgramTest).length" class="">
        <div class="educationCard pt-2" v-for="(item, index) in userProgramTest" :key="index+'program'" >
          <ProgramTest :propGideUser="propGideUser" :propProgramDetail="item" :propOpenedInModal="false" :propShowEditBox = "false"></ProgramTest>
        </div>
      </div>
    </b-modal><!-- showProgramTestModal -->

    <!-- Show spcm counsellor and student activities-->
    <b-modal
      v-model="showSpcmCounselerAndStudentActivity"
      scrollable
      size="xxl"
      :title="cvShowActivities">
      <SpcmCounselorCalendar :propOpenedInModal="true" :propSpcmObj="gideActivityObj" :propStudentData="studentData" @emitcloseSpcmCounselorCalendarModal="closeSpcmCounselorCalendarModal"/>
    </b-modal><!-- Show spcm counsellor and student activities-->

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { Spcms } from "../../../FackApi/api/Spcm.js"
import moment from "moment"
import ApiResponse from "../../../Utils/apiResponse.js"
import { socialvue } from "../../../config/pluginInit.js"
import InviteUser from "../../../components/InviteUser.vue"
// import { SpcmNotess } from "../../../FackApi/api/spcmNotes"
import { SpcmSessions } from "../../../FackApi/api/spcmSession.js"
import userPermission from "../../../Utils/user_permission.js"
import spcmCountryStrategyAdd from "./spcmCountryStrategyAdd.vue"
import { SpcmCounsellors } from "../../../FackApi/api/SpcmCounsellor.js"
import SpcmStudentCounsellorTeam from "./SpcmStudentCounsellorTeam.vue"
import ChangeStrategist from "./SpcmChangeStrategist.vue"
import ColorCodes from "../../../Utils/colorcodes.js"
import GideContract from "./GideContract.vue"
import GideContractJSON from "../../../FackApi/json/GideContract.json"
import { Admissions } from "../../../FackApi/api/admission.js"
import Multiselect from "vue-multiselect"
import ProgramTest from "../../../components/UserProfile/ProgramTest.vue"
import { User } from "../../../FackApi/api/user.js"
import Utility from "../../../Utils/utility.js"
import Class from "../../../FackApi/json/Class.json"
import SpcmCounselorCalendar from "../../../components/SpcmCounselorCalendar.vue"
import NotificationsModal from "./NotificationsModal.vue"

export default {
  name: "SpcmList",
  components: {
    ChangeStrategist,
    InviteUser,
    spcmCountryStrategyAdd,
    SpcmStudentCounsellorTeam,
    GideContract,
    Multiselect,
    ProgramTest,
    SpcmCounselorCalendar,
    NotificationsModal
  },
  data () {
    return {
      VUE_APP_ENV: process.env.VUE_APP_ENV,
      apiName: "spcm_list",
      cvCardTitle: "Counseling Dashboard V1",
      cvCardTitleIsApprove: "Student Approval Dashboard",
      cvbtnFirefliesDashboard: "Fireflies",
      cvSearchText: "Type to Search",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      cvShowActivities: "Book Appointment",
      cvAddStrategyModalHeader: "Add/Edit Country Strategy",
      cvbtnSpcmCounsolerDashboard: "Counseling Team",
      cvSpcmStudentCounsellorTeamModalHeader: "Student Counselor Team",
      cvChangeCounsellorModalTitle: "Change Strategist",
      showSpcmCounselerAndStudentActivity: false,
      showChangeCounsellorModal: false,
      cvbtnModalCancel: "Close",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Counseling",
      showModelSpcmAdd: false,
      showModelSpcmDelete: false,
      showModelSpcm_Country_StrategyAdd: false,
      showModelSpcmStudentCounsellorTeam: false,
      sortBy: "name",
      sessionList: [],
      sortDesc: false,
      columns: [],
      spcmObjList: null,
      StudentCounsellorTeamObj: null,
      spcmStrategyObj: null,
      filter: null,
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 50,
      spcmObj: null,
      whereFilter: {
        counsellor_id: null,
        spcm_state: null,
        spcm_category: null,
        Class: "All"
      },
      search_param: "",
      counsellorObjList: [],
      adminView: false,
      counsellorView: false,
      counsellorId: null,
      Class: Class,
      new_spcm_category: null,
      cvbtnCreateSession: "Invite",
      cvbtnBlockCalendar: "Calendar",
      cvModalTitle: "Invite",
      showInviteUserModal: false,
      showModelSpcmStatusUpdate: false,
      showModelSpcmCategoryUpdate: false,
      SPCM_STATE_LIST: {},
      SPCM_CATEGORY_LIST: {},
      SPCM_STATE_COLORCODE_LIST: {},
      updateInfo: 0,
      propSpcmUser: {},
      userSubsPdtMap: {},
      cvbtnGideContract: "View GIDE Counseling Contract",
      showModalGideContracts: false,
      gideCounselingContractObj: null,
      gideContractJSON: GideContractJSON,
      csvTitle: "CounselingDashboard",
      univFiltersList: { "org_name , org_id": [] },
      universityFilterObj: { org_name: "Choose University", org_id: 0 },
      showProgramTestModal: false,
      userProgramTest: {},
      showLoadMoreBtn: true,
      currentBatchNo: 1,
      dataPerPage: 25,
      doCopy: Utility.doCopy,
      propGideUser: null,
      gideActivityObj: null,
      studentData: null,
      isBusy: true,
      propNotificationObj: {},
      cvbtnSpcmCaseSummary: "Counseling Report",
      salesQuestionObj: null,
      isApprove: false
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    dateFilter () {
      return { ...this.$store.getters["DateFilter/selectedDateState"] }
    },
    sortedCounsellorList () {
      return [...this.counsellorObjList].sort((a, b) =>
        a.user_name.localeCompare(b.user_name)
      )
    },
    filteredClasses () {
      return Object.values(this.Class).map(c => {
        return {
          value: c,
          label: c === "Other" ? "All" : this.fixedClassName(c)
        }
      })
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    socialvue.index()

    if (this.userData.user_role == "USERROLE11111") {
      this.adminView = true
    }
    else if (this.userData.user_role == "USERROLE11118") {
      if (userPermission(this, this.userData, "spcm_approve")) {
        this.adminView = true
      }
      this.counsellorView = true
      this.counsellorId = this.userData.user_id
    }

    let notificationModuleName = "SPCM"
    if (this.$route.query.deleted == 2 || this.$route.query.tobeapproved == 1) {
      this.isApprove = true
      notificationModuleName = "INVITE_USER"
    }

    this.univFilterList("org_name , org_id")
    this.spcmStateList()
    this.spcmList()
    this.getCounselorFilterList()
    this.setUserView()
    this.spcmCategory()

    if (this.userData.user_role === "USERROLE11111" || this.userData.user_role === "USERROLE11118") {
      this.propNotificationObj = {
        module_name: notificationModuleName,
        module_id: null,
        counsellorId: this.userData.user_id,
        gide_user_id: null,
        seen_status: 0
      }
    }
  },
  methods: {
    /**
     * setUserView
     */
    setUserView () {
      switch (this.userData.user_role) {
        case "USERROLE11111":
          this.columns = [
            { label: "# ", key: "id", class: "text-left align-text-top w-50px", sortable: true },
            { label: "Student Info", key: "user_name", class: "text-left align-text-top w-300px", sortable: true },
            { label: "Grade", key: "grade", class: "text-left align-text-top w-150px", sortable: true },
            // { label: "Applications", key: "university", class: "text-left align-text-top w-300px", sortable: true },
            // { label: "course", key: "cour_name", class: "text-left align-text-top w-200px", sortable: true },
            // { label: "Application Deadline", key: "org_application_deadline_forstudent w-200px", class: "text-left align-text-top", sortable: true },
            // { label: "Intake", key: "batch", class: "text-left align-text-top w-150px", sortable: true },
            // { label: "Test Score", key: "exam_name", class: "text-left align-text-top w-300px", sortable: true },
            { label: "services ", key: "spcm_category", class: "text-left align-text-top w-300px", sortable: true },
            { label: "Status", key: "spcm_state", class: "text-left align-text-top w-125px", sortable: true },
            { label: "Country Strategy", key: "ms_country_strategy", class: "text-left align-text-top w-125px", sortable: true },
            { label: "Parent Info", key: "parent_details", class: "text-left align-text-top w-260px", sortable: true },
            // { label: "Current Progress", key: "spcm_id", class: "text-left align-text-top w-300px", sortable: true },
            { label: "Lead Strategist", key: "strategist", class: "text-left align-text-top w-200px", sortable: true },
            // { label: "Terms", key: "trems_conditions", class: "text-left align-text-top", sortable: true },
            { label: "sales", key: "sales_person", class: "text-left align-text-top", sortable: true },
            { label: "Added On", key: "created_on", class: "text-left align-text-top w-150px", sortable: true }
          ]
          break
        case "USERROLE11118":
          this.columns = [
            { label: "# ", key: "id", class: "text-left align-text-top w-50px", sortable: true },
            { label: "Student Info", key: "user_name", class: "text-left align-text-top w-300px", sortable: true },
            { label: "Grade", key: "grade", class: "text-left align-text-top w-150px", sortable: true },
            // { label: "Applications", key: "university", class: "text-left align-text-top w-300px", sortable: true },
            // { label: "course", key: "cour_name", class: "text-left align-text-top w-200px", sortable: true },
            // { label: "Application Deadline", key: "org_application_deadline_forstudent w-200px", class: "text-left align-text-top", sortable: true },
            // { label: "Intake", key: "batch", class: "text-left align-text-top w-150px", sortable: true },
            // { label: "Test Score", key: "exam_name", class: "text-left align-text-top w-300px", sortable: true },
            { label: "services ", key: "spcm_category", class: "text-left align-text-top w-350px", sortable: true },
            { label: "Status", key: "spcm_state", class: "text-left align-text-top w-125px", sortable: true },
            { label: "Country Strategy", key: "ms_country_strategy", class: "text-left align-text-top w-125px", sortable: true },
            { label: "Parent Info", key: "parent_details", class: "text-left align-text-top w-260px", sortable: true },
            // { label: "Current Progress", key: "spcm_id", class: "text-left align-text-top w-300px", sortable: true },
            { label: "Lead Strategist", key: "strategist", class: "text-left align-text-top w-175px", sortable: true },
            // { label: "Terms", key: "trems_conditions", class: "text-left align-text-top", sortable: true },
            { label: "sales", key: "sales_person", class: "text-left align-text-top", sortable: true },
            { label: "Added On", key: "created_on", class: "text-left align-text-top w-150px", sortable: true }
          ]
      }
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      if (this.isBusy) return
      this.currentBatchNo = this.currentBatchNo + 1
      this.spcmList(true)
    },
    /**
     * searchFromBackend
     */
    searchFromBackend () {
      if (this.search_param.length <= 1) {
        return
      }
      this.spcmList()
    },
    /**
     * get Counselling State Color Code
     */
    getCounsellingStateColorCode (stateId) {
      if (stateId == "tnc_1") {
        return `vertical-align: middle; color: #FFF; background: green !important;`
      }
      else if (stateId == "tnc_0") {
        return `vertical-align: middle; color: #FFF; background: orange !important;`
      }
      else if (stateId == 99) {
        return `vertical-align: middle; color: #FFF; background: orange !important;`
      }
      else if (stateId == 98) {
        return `vertical-align: middle; color: #FFF; background: #e5252c !important;`
      }
      else if (stateId == "approve") {
        return `vertical-align: middle; color: #FFF; background: red !important;`
      }
      else if (stateId == "approved") {
        return `vertical-align: middle; color: #FFF; background: green !important;`
      }
      else if (stateId == "error") {
        return `vertical-align: middle; color: #FFF; background: red !important;`
      }
      else {
        return `vertical-align: middle; color: #FFF; background: ${this.SPCM_STATE_COLORCODE_LIST[stateId]} !important;`
      }
    },
    /**
     * setCounsellor
    */
    async setCounsellor () {
      // console.log("XXXX setCounsellor called", this.whereFilter.counsellor_id)
      this.spcmList()
    },
    /**
     * emitCloseInviteUser
     * User Invited from Counseling Dashboard
     */
    async emitCloseInviteUser (inviteAddResp, slot, otherEmail = null) {
      if (slot) {
        let payload = {
          // user_id: this.userData.user_id,
          participant_id: inviteAddResp.resp_data.user.user_id,
          session_title: `Session ${this.sessionList.length + 1}`,
          spcm_id: inviteAddResp.resp_data.spcm.spcm_id,
          session_start_ts: slot.slot_start_ts,
          session_end_ts: Number(slot.slot_start_ts) + slot.slot_duration,
          counsellor_id: this.userData.user_id,
          spcm_calendar_id: slot.spcm_calendar_id,
          session_state: null,
          source: "spcm" + this.userData.user_id,
          user_email: inviteAddResp.resp_data.user.user_email,
          screen: "SpcmSessions-emitCloseInviteUser"
        }

        if (otherEmail) {
          payload.other_email_id = otherEmail
        }

        let sessionAddResponse = await SpcmSessions.spcmSessionAdd(this, payload)
        if (!sessionAddResponse.resp_status) {
          this.toastMsg = sessionAddResponse.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
          return
        }
      }
      this.spcmList()
    },
    /**
     * emit Close Change Counselllor
     */
    emitCloseChangeCounselllor () {
      this.spcmList()
      this.showChangeCounsellorModal = false
    },
    /**
     * goToCalendar
     */
    goToCalendar () {
      this.$router.push(`spcmCalendar_list/${this.userData.user_id}`)
    },
    /**
     * viewDetails
     */
    viewDetails (path) {
      window.open(path, "_blank")
    },
    /**
     * gotoInviteUser
     */
    gotoInviteUser () {
      window.open("/inviteV1?category=sales")
    },
    /**
     * inviteUserModal
     */
    inviteUserModal () {
      this.salesQuestionObj = {
        app_id: "PRE_COUNSELING_APP_ID",
        qbk_category: "sales"
      }
      this.showInviteUserModal = true
    },
    /**
     * gotoFirefliesDashboard
     */
    gotoFirefliesDashboard () {
      this.$router.push(`FireFliesList`)
    },
    /**
     * inviteUserModalClose
     */
    inviteUserModalClose () {
      this.showInviteUserModal = false
      this.spcmList()
    },
    /**
     * viewSessionDetails
     */
    viewSessionDetails (spcmSessionId) {
      window.open(`/spcm1/${spcmSessionId}`, "_blank")
    },
    /**
     * gotoSpcmCounsellorTeamDashboard
    */
    gotoSpcmCounsellorTeamDashboard () {
      this.$router.push(`/spcm_counseling_team`)
    },
    /**
     * gotoSpcmCaseSummary
     */
    gotoSpcmCaseSummary () {
      this.$router.push(`/spcm_analytics_case_summary`)
    },
    /**
     * Calling Function as per whereFilter
    */
    async getspcmDateWise () {
      this.spcmList()
    },
    /**
     * getCounselorFilterList
     */
    async getCounselorFilterList () {
      const counselorsListResp = await SpcmCounsellors.spcmCounsellorList()
      if (counselorsListResp.resp_status) {
        this.counsellorObjList = counselorsListResp.resp_data.data
      }
    },
    /**
     * spcmStateList
     */
    async spcmStateList () {
      try {
        let spcmStateListResp = await Spcms.spcmStateList(this)
        if (spcmStateListResp.resp_status) {
          let stateObjList = spcmStateListResp.resp_data.data
          for (let stateObj of stateObjList) {
            this.SPCM_STATE_LIST[stateObj.state_id] = stateObj.state
            this.SPCM_STATE_COLORCODE_LIST[stateObj.state_id] = stateObj.state_color_code
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at spcmStateList() and Exception:", err.message)
      }
    },
    /**
     * spcmList
     */
    async spcmList (loadViaLoadMore = false, downloadCsv = false) {
      this.isBusy = true
      try {
        if (this.isApprove) {
          this.whereFilter.deleted = 2
        }

        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage
        this.whereFilter.downloadCsv = downloadCsv
        this.whereFilter.search_param = this.search_param

        if (this.universityFilterObj && this.universityFilterObj.org_id) {
          this.whereFilter.orgId = this.universityFilterObj.org_id
          this.whereFilter.orgName = this.universityFilterObj.org_name
        }

        let spcmListResp = await Spcms.spcmList(this, this.whereFilter)
        if (spcmListResp.resp_status) {
          if (downloadCsv) {
            window.open(spcmListResp.resp_csv_file_url)
            return
          }

          if (this.whereFilter.search_param.length >= 0 && !loadViaLoadMore) {
            this.spcmObjList = [ ...spcmListResp.resp_data.data ]
          }
          else {
            this.spcmObjList = [ ...this.spcmObjList, ...spcmListResp.resp_data.data ]
          }

          this.showLoadMoreBtn = true
          this.spcmObjList.forEach((s, index) => { s.id = index + 1 })
          // this.spcmObjList = spcmListResp.resp_data.data
          this.totalRows = this.spcmObjList?.length ? this.spcmObjList.length : 0
          this.userSubsPdtMap = spcmListResp.user_product_map
        }
        else {
          this.currentBatchNo = this.currentBatchNo == 1 ? 1 : (this.currentBatchNo - 1)
          this.showLoadMoreBtn = false
          this.toastMsg = spcmListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
          this.spcmObjList = null
        }

        this.updateInfo = this.updateInfo + 1
      }
      catch (err) {
        console.error("Exception occurred at spcmList() and Exception:", err.message)
      }
      finally {
        this.isBusy = false
      }
    },
    /**
     * spcm Status Update
     */
    async spcmStatusUpdate (spcmObj, newState) {
      try {
        this.cvLoadingStatus = true

        let payload = {
          spcm_id: spcmObj.spcm_id,
          spcm_state: newState
        }
        let spcmAddResp = await Spcms.spcmStateEdit(this, payload)
        await ApiResponse.responseMessageDisplay(this, spcmAddResp)

        if (spcmAddResp && !spcmAddResp.resp_status) {
          return false
        }

        spcmObj.spcm_state = newState
        this.showModelSpcmStatusUpdate = false
      }
      catch (err) {
        console.error("Exception occurred at spcmStatusUpdate() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * show Spcm Status Update Dialog
     */
    showSpcmStatusUpdateOpenDialog (spcmObj) {
      this.spcmObj = spcmObj
      this.showModelSpcmStatusUpdate = true
    },
    /**
     * showSpcmDeleteDialog
     */
    showSpcmDeleteDialog (spcmObj) {
      try {
        this.spcmObj = spcmObj
        this.showModelSpcmDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showSpcmDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * spcmDelete
     */
    async spcmDelete () {
      try {
        let spcmDelResp = await Spcms.spcmDelete(this, this.spcmObj.spcm_id)
        await ApiResponse.responseMessageDisplay(this, spcmDelResp)

        if (spcmDelResp && !spcmDelResp) {
          this.showModelSpcmDelete = false
          return false
        }

        let index = this.spcmObjList.indexOf(this.spcmObj)
        this.spcmObjList.splice(index, 1)
        this.totalRows = this.totalRows - 1
        this.showModelSpcmDelete = false
      }
      catch (err) {
        console.error("Exception occurred at spcmDelete() and Exception:", err.message)
      }
    },
    /**
     * closeSpcmAddModal
     */
    closeSpcmAddModal (spcmAddData) {
      try {
        if (spcmAddData) {
          if (this.spcmObjList && this.spcmObjList.length >= 1) {
            let spcmObjLength = this.spcmObjList.length
            let lastId = this.spcmObjList[spcmObjLength - 1]["id"]
            spcmAddData.id = lastId + 1
          }
          else {
            this.spcmObjList = []
            spcmAddData.id = 11111
          }

          spcmAddData.created_on = moment()
          this.spcmObjList.unshift(spcmAddData)
          this.totalRows = this.totalRows + 1
        }

        this.showModelSpcmAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closespcmAddModal() and Exception:", err.message)
      }
    },
    /**
     * close Spcm Country Strategy Modal
     */
    closeSpcmCountryStrategyModal (updatedData) {
      try {
        // Update the List with new Information
        if (updatedData && updatedData.spcm_id) {
          for (let i in this.spcmObjList) {
            if (this.spcmObjList[i].spcm_id == updatedData.spcm_id) {
              this.spcmObjList[i] = updatedData
              break
            }
          }
          this.updateInfo = this.updateInfo + 1
        }

        this.showModelSpcm_Country_StrategyAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closeSpcmCountryStrategyModal() and Exception:", err.message)
      }
    },
    /**
     * openReport
     */
    openReport (url) {
      window.open(url, "_blank")
    },
    /**
     * getNotes
     */
    getNotes (data) {
      return data.latest_counselor_notes ? data.latest_counselor_notes.slice(0, 200) + `<br><br><span class='primary-color pointer'>Read More ...</span>` : ""
    },
    /**
     * spcm_country_strategyAdd
    */
    spcm_country_strategyAdd (type, item) {
      this.spcmStrategyObj = item
      this.showModelSpcm_Country_StrategyAdd = true
    },
    /**
     * showChangeCounsellor
     */
    showChangeCounsellor (spcmUser) {
      this.propSpcmUser = {
        gide_user_id: spcmUser.user_id,
        stu_name: spcmUser.user_name,
        stu_email: spcmUser.user_email,
        spcm_id: spcmUser.spcm_id,
        counsellor_id: spcmUser.counsellor_id,
        counsellor_name: spcmUser.counsellor_name,
        history: spcmUser.history,
        counselor_team: spcmUser.counselor_team
      }
      this.showChangeCounsellorModal = true
    },

    /**
     * spcmStudentCounsellorTeam
    */
    spcmStudentCounsellorTeam (type, item) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/spcmStudentCounsellor_team/" + this.StudentCounsellorTeamObj.spcm_id)
        }
        else {
          this.StudentCounsellorTeamObj = item
          this.showModelSpcmStudentCounsellorTeam = true
        }
      }
      catch (err) {
        console.error("Exception occurred at spcmStudentCounsellorTeam() and Exception:", err.message)
      }
      // this.$router.push(`/spcmStudentCounsellor_team/${spcmCounsellorId}`)
    },
    /**
     * spcmCategory
     */
    async spcmCategory () {
      try {
        let spcmCategoryListResp = await Spcms.spcmCategoryList(this)
        if (spcmCategoryListResp.resp_status) {
          let categoryObjList = spcmCategoryListResp.resp_data.data
          this.SPCM_CATEGORY_LIST = categoryObjList
        }
      }
      catch (err) {
        console.error("Exception occurred at spcmCategoryList() and Exception:", err.message)
      }
    },
    /**
     * closeStudentCounsellorTeamModal
     */
    closeStudentCounsellorTeamModal (updatedData) {
      try {
        // Update the List with new Information
        for (let i in this.spcmObjList) {
          if (this.spcmObjList[i].spcm_id == updatedData.spcm_id) {
            this.spcmObjList[i] = updatedData
            break
          }
        }

        this.updateInfo = this.updateInfo + 1
        this.showModelSpcmStudentCounsellorTeam = false
      }
      catch (err) {
        console.error("Exception occurred at closeStudentCounsellorTeamModal() and Exception:", err.message)
      }
    },
    /**
     * show Spcm Category Update Dialog
     */
    showSpcmCategoryUpdateOpenDialog (spcmObj) {
      this.spcmObj = spcmObj
      this.new_spcm_category = spcmObj.spcm_category
      this.showModelSpcmCategoryUpdate = true
    },
    /**
     * spcm category Update
     */
    async spcmCategoryUpdate (spcmObj, newCategory) {
      try {
        this.cvLoadingStatus = true

        let payload = {
          spcm_id: spcmObj.spcm_id,
          spcm_category: newCategory
        }

        let spcmAddResp = await Spcms.spcmCategoryEdit(this, payload)
        await ApiResponse.responseMessageDisplay(this, spcmAddResp)

        if (spcmAddResp && !spcmAddResp.resp_status) {
          return false
        }

        spcmObj.spcm_category = newCategory
        this.spcmList()
        this.showModelSpcmCategoryUpdate = false
      }
      catch (err) {
        console.error("Exception occurred at spcmCategoryUpdate() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * getBgFor
     */
    getBgFor (category) {
      switch (category) {
        case "Partner":
        case "GIDE-PARTNER":
          return ColorCodes.getBgColor(24)
        case "GIDE-ONE":
          return ColorCodes.getBgColor(3)
        case "SPCM-TESTSERIES":
          return ColorCodes.getBgColor(6)
        case "SPCM-GIDEPREP":
        case "GIDEPREP":
          return ColorCodes.getBgColor(4)
        case "Premium":
        case "GIDE-EXCLUSIVE":
          return ColorCodes.getBgColor(10)
      }
    },
    /**
     * parse and get the data
     */
    getProgramAndTest (programs) {
      try {
        return JSON.parse(programs)
      }
      catch (e) {
        return {}
      }
    },
    /**
     * goToUserSubscriptions
     */
    goToUserSubscriptions (userid) {
      window.open(`my_billing_history/${userid}`)
    },
    /**
     * getStateColorCode
     */
    getStateColorCode (registrationState = null) {
      if (registrationState && registrationState != 1) {
        return `vertical-align: middle; color: #FFF; background: #FF9900 !important;`
      }
      else {
        return `vertical-align: middle; color: #FFF; background: #e5252c !important;`
      }
    },
    /**
     * view Gide contracts
     */
    viewContract (item, category) {
      this.gideCounselingContractObj = { ...item }

      if (category.includes("GIDEPREP")) {
        this.gideCounselingContractObj.tprep_id = item.spcm_id // Only required for spcm_edit
        this.gideCounselingContractObj.tprep_id = item.tprep_id
        this.gideCounselingContractObj.spcm_category = "SPCM-GIDEPREP"
        this.gideCounselingContractObj.spcm_contract = item.tprep_contract
        this.gideCounselingContractObj.spcm_tnc = item.tprep_tnc
      }
      else if (category.includes("EXCLUSIVE")) {
        this.gideCounselingContractObj.spcm_category = "GIDE-EXCLUSIVE"
        this.gideCounselingContractObj.spcm_contract = item.spcm_contract
        this.gideCounselingContractObj.spcm_tnc = item.spcm_tnc
      }

      this.gideCounselingContractObj.blog_id = this.gideContractJSON[this.gideCounselingContractObj.spcm_category]
      this.showModalGideContracts = true
    },
    /**
     * Spcms TnC Accept and contract upload
     */
    async contractTnCAccept (contractObj, category = null) {
      const isModalAcceptance = contractObj && Array.isArray(contractObj.spcm_contract)
      const isToggleRequest = typeof contractObj === "object" && !isModalAcceptance
      const selectedContract = isToggleRequest ? contractObj : this.gideCounselingContractObj

      if (!selectedContract || !selectedContract.spcm_id) {
        return false
      }

      const payload = {
        spcm_id: selectedContract.spcm_id,
        spcm_category: category || contractObj.spcm_category
      }

      let tncFlag = null
      if ((category || contractObj.spcm_category).includes("GIDEPREP")) {
        tncFlag = isToggleRequest ? (Number(selectedContract.tprep_tnc) === 1 ? 0 : 1) : (contractObj.acceptTnc ? 1 : Number(selectedContract.tprep_tnc))
        payload.tprep_id = selectedContract.tprep_id
        payload.tprep_tnc = tncFlag
      }
      else if ((category || contractObj.spcm_category).includes("EXCLUSIVE")) {
        tncFlag = isToggleRequest ? (Number(selectedContract.spcm_tnc) === 1 ? 0 : 1) : (contractObj.acceptTnc ? 1 : Number(selectedContract.spcm_tnc))
        payload.spcm_id = selectedContract.spcm_id
        payload.spcm_tnc = tncFlag
      }

      // TnC Accepted on Modal Box, then send the contract and category to backend for update
      if (isModalAcceptance) {
        payload.spcm_contract = contractObj.spcm_contract
      }

      const spcmEditResp = await Spcms.spcmEdit(this, payload)

      await ApiResponse.responseMessageDisplay(this, spcmEditResp)
      if (!spcmEditResp || !spcmEditResp.resp_status) {
        return false
      }

      if ((category || contractObj.spcm_category).includes("GIDEPREP")) {
        selectedContract.tprep_tnc = tncFlag
      }
      else if ((category || contractObj.spcm_category).includes("EXCLUSIVE")) {
        selectedContract.spcm_tnc = tncFlag
      }

      if (isToggleRequest) {
        this.updateInfo = this.updateInfo + 1
      }
      else {
        this.closeGIDECounselingContractModal()
      }
    },
    /**
     * close GIDECounselingContractModal
     */
    closeGIDECounselingContractModal () {
      try {
        this.showModalGideContracts = false
        this.spcmList()
      }
      catch (err) {
        console.error("Exception occurred at closeGIDECounselingContractModal() and Exception:", err.message)
      }
    },
    /**
     * view Gide Activity
     */
    viewSpcmActivity (item) {
      this.gideActivityObj = {
        spcm_id: item.spcm_id,
        // counsellor_id: item.counsellor_id,
        // counsellor_name: item.counsellor_name,
        student_id: item.user_id,
        student_name: item.user_name
      }

      this.studentData = item

      this.showSpcmCounselerAndStudentActivity = true
    },
    /**
     * backendCsvDownload
    */
    async backendCsvDownload () {
      this.spcmList(true)
    },
    /*
    * univ Filter List
    */
    async univFilterList (filterName, searchfilter = null) {
      try {
        let univFilterListResp = await Admissions.admissionOrganisationFilterList(this, searchfilter)
        if (univFilterListResp) {
          this.univFiltersList[filterName] = univFilterListResp.resp_data
        }
      }
      catch (err) {
        console.error("Exception occurred at univFilterList() and Exception:", err.message)
      }
    },
    /**
     * userProfileView
     */
    async userProfileView (userId) {
      let userProfileViewResp = await User.userProfileView(this, userId)
      if (userProfileViewResp.resp_status) {
        this.o2o_participant_id = userProfileViewResp.resp_data.data.user_id
        userProfileViewResp.resp_data.user_id = userProfileViewResp.resp_data.data.gide_user_id

        if (typeof userProfileViewResp.resp_data.data.user_profile === "string") {
          userProfileViewResp.resp_data.data.user_profile = JSON.parse(userProfileViewResp.resp_data.data.user_profile)
        }

        if (this.user_profile.education && Array.isArray(this.user_profile.education)) {
          for (let i = 0; i < this.user_profile.education.length; i++) {
            this.user_profile.education[i]["education"].class_name = this.fixedClassName(this.user_profile.education[i].education.class_name)
          }
        }
        this.userProgramTest = JSON.parse(userProfileViewResp.resp_data.data.user_program_test)
      }
    },
    /**
     * show Programs Model
     */
    showProgramTestModel (userData) {
      try {
        this.propGideUser = userData
        this.userProfileView(userData.user_id)
        this.showProgramTestModal = true
      }
      catch (err) {
        console.error("Exception occurred at showProgramTestModel() and Exception:", err.message)
      }
    },
    /**
     * goto Admission Dashboard
     */
    gotoAdmissionDashboard (userId) {
      let url = `./admission_dashboard/${userId}`
      window.open(url, "_blank")
    },
    /**
     * remove All Filter
     */
    removeAllFilter () {
      this.whereFilter = {
        counsellor_id: null,
        spcm_state: null,
        spcm_category: null
      }

      this.universityFilterObj = { org_name: "Choose University", org_id: 0 }
      this.univFiltersList = { "org_name , org_id": [] }
      this.spcmList(false)
    },
    /**
     * fixedClassName
     */
    fixedClassName (className) {
      if (className == 0) {
        return "-"
      }
      else if (className == 13) {
        return "Graduation"
      }
      else if (className == 14) {
        return "Post Graduation"
      }
      else if (className == 15) {
        return "PhD"
      }
      else {
        return className
      }
    },
    /*
     * close Spcm Counselor Calendar Modal
     */
    closeSpcmCounselorCalendarModal () {
      this.showSpcmCounselerAndStudentActivity = false
    },
    /**
     * spcm Approve
     */
    async spcmApprove (spcm, status, category) {
      let payload = {
        spcm_id: spcm.spcm_id,
        deleted: status,
        spcm_category: category,
        gide_user_id: spcm.user_id
      }

      const spcmResp = await Spcms.spcmApprove(this, payload)
      if (spcmResp && spcmResp.resp_status) {
        spcm.deleted = payload.deleted

        if (spcm.spcm_category.includes("GIDEPREP") && spcm.deleted == 0) {
          this.StudentCounsellorTeamObj = spcm
          this.StudentCounsellorTeamObj.adminView = true
          this.showModelSpcmStudentCounsellorTeam = true
        }
      }

      if (spcmResp && spcmResp.resp_status) {
        this.spcmList()
      }
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="css" scoped>
  .button_align{
    display: inline-flex;
    width: auto;
    border: 0px;
  }
  .action_buttons{
    display: inline-flex;
    align-items: flex-end;
  }
</style>
